import create from "zustand";
import {PaginationPerson} from "../interface/query/paginationPerson";

interface Storage {
    list?: PaginationPerson | null;
    setList: (list: PaginationPerson | null | undefined) => void;
}

export const useSearchPersonStorage = create<Storage>((set) => ({
    list: null,
    setList: (list: any) => set({ list }),
}));
